// src/api/apiPricingUnits.js
import axios from "../utils/axios";

/// Get Pricing Units
export const getAllPricingUnits = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("pricing-units", { params });
    return data;
};
// Get pricing units for Select Dropdown
export const getPricingUnitsForSelect = async () => {
    const { data } = await axios.get("pricing-units/for-select");
    return data;
};

/// Get Pricing Unit
export const getPricingUnit = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`pricing-units/${id}`);
    return data;
};

/// Create Pricing Unit
export const createPricingUnit = async (req) => {
    try {
        const { data } = await axios.post("pricing-units", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createPricingUnit error:", error);
        throw error;
    }
};

/// Update Pricing Unit
export const updatePricingUnit = async (req, id) => {
    try {
        const { data } = await axios.put(`pricing-units/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updatePricingUnit error:", error);
        throw error;
    }
};

/// Delete Pricing Unit
export const deletePricingUnit = async (id) => {
    try {
        const { data } = await axios.delete(`pricing-units/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deletePricingUnit error:", error);
        throw error;
    }
};

/// Delete All Pricing Units
export const deleteAllPricingUnits = async (req = []) => {
    try {
        const { data } = await axios.delete(
            "pricing-units/mass-destroy",
            { data: req },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllPricingUnits error:", error);
        throw error;
    }
};

/// Restore Pricing Unit
export const restorePricingUnit = async (id) => {
    try {
        const { data } = await axios.post(`pricing-units/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restorePricingUnit error:", error);
        throw error;
    }
};

/// Restore multiple Pricing Units
export const restoreAllPricingUnits = async (req = []) => {
    try {
        const { data } = await axios.post(
            "pricing-units/mass-restore",
            { ...req },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllPricingUnits error:", error);
        throw error;
    }
};

/// Force Delete Pricing Unit
export const forceDeletePricingUnit = async (id) => {
    try {
        const { data } = await axios.delete(`pricing-units/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeletePricingUnit error:", error);
        throw error;
    }
};

/// Force Delete multiple Pricing Units
export const forceDeleteAllPricingUnits = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "pricing-units/mass-force-delete",
            { data: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllPricingUnits error:", error);
        throw error;
    }
};
